<template>
  <div
    class="navbar_dropdown border_rounded_pill text-no-wrap"
    :class="`
      padding-left_${size}
      padding-right_${size}
      ${isSelected ? 'navbar_dropdown--selected' : ''}
      ${link ? 'cursor-pointer' : ''}
      ${avatar ? 'padding-bottom_2xs padding-top_2xs' : 'padding-bottom_xs-df padding-top_xs-df'}
    `"
    @click="itemClicked({ path: link, title })"
    @keydown="itemClicked({ path: link, title })"
  >
    <div class="position-relative">
      <SvgFactory
        v-if="icon"
        class="margin-right_xs-df"
        :name="icon"
        :customColor="isSelected ? '#fff' : '#64748B'"
        :width=18
      />
      <SvgFactory
        v-if="showNotifications"
        name="icon_circle"
        customColor="#D33D59"
        class="navbar_dropdown--notification d-flex align-center justify-center"
        :width=8
      />
    </div>
    <Avatar v-if="avatar !== null" :profileImg="avatar" size="sm" class="margin-right_xs-df" />
    <span
      :id="createId(title)"
      class="medium-body-sm"
      :class="[isSelected ? 'typography_white' : 'typography_default']"
    >
      {{ title }}
    </span>
    <template v-if="shouldShowDropdown">
      <SvgFactory
        :class="`margin-left_xs-df arrow_icon`"
        name="icon_arrow_down"
        :width=20
        customColor="#64748B"
      />
      <div
        class="navbar_dropdown_menu"
        :class="[size, { 'avatar': showAvatar }]"
        :style="`${alignRight ? 'right: 0; left: auto;' : ''}`"
      >
        <div
          v-for="item in items"
          :key="item.title"
          class="navbar_dropdown_menu_item padding-top_sm padding-bottom_sm padding-left_sm padding-right_sm cursor-pointer"
          :style="`${item.title === 'Logout' ? 'justify-content: flex-start;' : ''}`"
          @click.stop="itemClicked(item)"
          @keydown.stop="itemClicked(item)">

          <SvgFactory
            v-if="item.title === 'Logout'"
            :class="`margin-right_xs-df`"
            name="icon_logout"
            :width=20
            customColor="#c03851"
          />
          <span
            :id="createId(item.title)"
            :class="`medium-body-sm ${item.title === 'Logout' ? 'typography_error' : 'typography_default' }`"
          >
            {{ item.title }}
          </span>
        </div>
        <hr v-if="footerItems.length && items.length" class="border_neutral_default border_stroke_sm_df" />
        <div
          v-for="item in footerItems"
          :key="item.title"
          class="navbar_dropdown_menu_item padding-top_sm padding-bottom_sm padding-left_sm padding-right_sm cursor-pointer"
          @click.stop="itemClicked(item)"
          @keydown.stop="itemClicked(item)">
          <span :id="createId(item.title)" class="bold-body-sm typography_default">
            {{ item.title }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Avatar from '@design_system_v2/atoms/Avatar.vue';
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';

export default {
  name: 'NavLink',
  emits: ['item-click'],
  components: {
    Avatar,
    SvgFactory,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    avatar: {
      type: String,
      default: null,
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    footerItems: {
      type: Array,
      default: () => ([]),
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    link: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    showNotifications: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    createId(title) {
      return `nav_link-${title.replace(/\W+/g, ' ')
        .split(/ |\B(?=[A-Z])/)
        .map((word) => word.toLowerCase())
        .join('_')}`;
    },
    itemClicked(item) {
      if (!item.path) { return; }
      this.$emit('item-click', item);
    },
  },
  computed: {
    shouldShowDropdown() {
      return this.items.length || this.footerItems.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@foundation";

.cursor-pointer {
  cursor: pointer !important;
}

.navbar_dropdown {
  display: flex;
  position: relative;
  align-items: center;
  cursor: default;

  &--selected {
    background-color: map-get($primary, 'purple-500');
  }

  &--notification {
    position: absolute;
    top: 0;
    right: 7px;
  }

  // #########################
  // #########################
  // ## Dropdown arrow icon ##
  // #########################
  // #########################
  .arrow_icon {
    transition: all 0.4s;
    transform: rotate(0deg);
  }

  &:not(.navbar_dropdown--selected):hover {
    background-color: map-get($neutral, 'neutral-200');
    .arrow_icon {
      transition: all 0.4s;
      transform: rotate(180deg);
    }
  }

  // ###################
  // ###################
  // ## Dropdown menu ##
  // ###################
  // ###################
  &:hover &_menu {
    display: block;
  }

  &_menu {
    height: auto;
    width: 400px;

    position: absolute;
    display: none;
    left: 0;

    z-index: 10010;
    overflow: hidden;

    @extend .border_rounded_lg;
    @extend .border_stroke_sm_df;
    @extend .border_color_neutral_default;
    @extend .background_neutral_white;

    &_item {
      display: flex;
      justify-content: space-between;
      &:hover {
        background-color: map-get($neutral, 'neutral-200');
      }
    }

    &.sm {
      top: 37px;
    }
    &.md {
      top: 48px;
    }
    &.avatar {
      top: 40px;
    }
  }
}
</style>
